import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface AppealsSelectionState {
  selectedIds: string[];
}

const initialState: AppealsSelectionState = {
  selectedIds: [],
};

export const appealsSelectionSlice = createSlice({
  name: 'appealsSelection',
  initialState,
  reducers: {
    toggleSelection: (state, action: PayloadAction<string>) => {
      const id = action.payload;
      const index = state.selectedIds.indexOf(id);
      if (index === -1) {
        state.selectedIds.push(id);
      } else {
        state.selectedIds.splice(index, 1);
      }
    },
    selectMultiple: (state, action: PayloadAction<string[]>) => {
      const idsToAdd = action.payload.filter(
        id => !state.selectedIds.includes(id),
      );
      state.selectedIds.push(...idsToAdd);
    },
    deselectMultiple: (state, action: PayloadAction<string[]>) => {
      const idsToRemove = new Set(action.payload);
      state.selectedIds = state.selectedIds.filter(id => !idsToRemove.has(id));
    },
    clearSelection: state => {
      state.selectedIds = [];
    },
  },
  selectors: {
    selectSelectedIds: state => state.selectedIds,
    selectSelectionCount: state => state.selectedIds.length,
  },
});

export const {
  toggleSelection,
  selectMultiple,
  deselectMultiple,
  clearSelection,
} = appealsSelectionSlice.actions;

export const { selectSelectedIds, selectSelectionCount } =
  appealsSelectionSlice.selectors;

export default appealsSelectionSlice;
